export default "__VITE_ASSET__Bt56hyhD__"